import type { ConversationStatus } from 'lib-shared-types-api';

/**
 * Gets conversation status by enriching the provided one with additional status
 * if necessary.
 *
 * @param status The conversation status to enrich.
 */
export function getEnrichedConversationStatus(
  status: readonly ConversationStatus[],
): readonly ConversationStatus[] {
  const result = new Set<ConversationStatus>(status);

  if (result.has('open') || result.has('pending')) {
    result.add('awaitingpending');
  }

  if (result.has('closed')) {
    result.add('pending');
  }

  return Array.from(result);
}
